import React from 'react';
//@ts-ignore
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import {DarkTheme, MainTheme} from "./config/Theme";
import {StyledEngineProvider, ThemeProvider } from "@mui/material";
import {Provider} from "react-redux";
import {APP_CONFIG, MAIN_APP_TITLE } from "./config/GeneralConfig";
import { setXsrfCookie } from './config/RouteConfig';
//import {LocalizationProvider} from "@mui/lab";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { de } from "date-fns/locale";
import { LocalizationProvider } from '@mui/x-date-pickers';
import {createEpicMiddleware} from "redux-observable";
import {applyMiddleware, legacy_createStore} from "redux";
import {RootReducer} from "./reducers/RootReducer";
import {composeWithDevTools} from "@redux-devtools/extension";
import {RootEpic} from "./actions/RootEpic";
import {GoogleAnalytics} from "./components/analytics/GoogleAnalytics";
import {CookieBanner} from "./components/analytics/CookieBanner";
import {VisibilityHandler} from "./components/common/VisibilityHandler";



setXsrfCookie();

document.title = MAIN_APP_TITLE;

const rootContainer = document.getElementById('root');
const root = createRoot( rootContainer! );

export const epicMiddleware = createEpicMiddleware();

//create redux Store
export const store = legacy_createStore(
    RootReducer,
    ( APP_CONFIG.devMode )
        ?  composeWithDevTools( applyMiddleware( epicMiddleware ) )
        : applyMiddleware(epicMiddleware)
);

// @ts-ignore
epicMiddleware.run( RootEpic );


const userPreferredTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? DarkTheme : MainTheme;


root.render(
    <Provider store={store}>
        <Router>
            {
                process.env.NODE_ENV === 'production'
                ? (
                    <GoogleAnalytics measurementId="G-PTD8402JZ7" />
                )
                : null

            }
            <LocalizationProvider adapterLocale={ de } dateAdapter={ AdapterDateFns }>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={userPreferredTheme}>
                        <App />
                        <CookieBanner />
                    </ThemeProvider>
                </StyledEngineProvider>
            </LocalizationProvider>
        </Router>
    </Provider>
);


